import { render, staticRenderFns } from "./solar.vue?vue&type=template&id=0fb994d4"
import script from "./solar.vue?vue&type=script&lang=js"
export * from "./solar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports